module.exports = __webpack_public_path__ + "static/img/honor20.211ee4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor20.png
// module id = 7qnG
// module chunks = 0